import React, { Component } from 'react'
import { HorizontalBar } from 'react-chartjs-2'
import BarGraph from '../common/graphs/barGraph'
import axios from 'axios'
import LineGraph from '../common/graphs/lineGraph'
import VerticalBarGraph from '../common/graphs/verticalBar'
import { CARRIER_STATS } from '../../config/rest_endpoints'

class CarrierStats extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stats: [],
            newStats: [],
        }
    }


    componentWillReceiveProps(newProps) {
        this.setState({
            newStats: newProps.carrier
        }, () => {
            this.renderCarrierGraph()
        })
    }

    renderCarrierGraph() {
        const { newStats } = this.state
        let x = [];
        let y = [];
        let z = [];
        for (var key in newStats) {
            let { id, sessions, cps } = newStats[key]
            x.push(id)
            y.push(sessions)
            z.push(cps)
        }
       
        this.setState({ x, y, z })
    }


    render() {
        const { x, y, z } = this.state
        return (
            <div className="row">
                <div className="col-md-11">
                    <VerticalBarGraph title="Sessions" secondTitle="CPS" x={x} y={y} a={z} width={800} height={300}  />
                </div>
                <div className="col-md-1"></div>
            </div>
        )
    }
}
export default CarrierStats


    // < div className = "col-md-6" >
    //     <div classname="card border-left-blue border-right-blue">
    //         <div classname="card-header header-elements-inline">
    //             <h6 classname="card-title">Sessions </h6>

    //             <div classname="header-elements">
    //                 {/* <span><i classname="icon-arrow-down22 text-danger"></i> <span classname="font-weight-semibold">- 29.4%</span></span> */}
    //             </div>
    //         </div>

    //         <div classname="tab-content card-body">
    //             {/* <BarGraph title="" x={names} y={currentCall} width={400} height={250} /> */}
    //             <VerticalBarGraph title="" x={x} y={y} width={400} height={250} />
    //             {/* <LineGraph title="" x={x} y={y} width={400} height={250} /> */}
    //         </div>
    //     </div>
    //             </div >
    // <div className="col-md-6">
    //     <div classname="card border-left-blue border-right-blue">
    //         <div classname="card-header header-elements-inline">
    //             <h6 classname="card-title">CPS </h6>

    //             <div classname="header-elements">
    //                 {/* <span><i classname="icon-arrow-down22 text-danger"></i> <span classname="font-weight-semibold">- 29.4%</span></span> */}
    //             </div>
    //         </div>

    //         <div classname="tab-content card-body">
    //             <BarGraph title="" x={x} y={z} width={400} height={250} />
    //             {/* <LineGraph title="" x={names} y={Cps} width={400} height={250} /> */}
    //             {/* <VerticalBarGraph title="" x={x} y={z} width={400} height={250} /> */}
    //         </div>
    //     </div>
    // </div>